"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectEffectHandler = exports.RedirectEffectArgs = void 0;
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class RedirectEffectArgs {
    constructor(damagesToAbsorb, damageAmount, actorIds) {
        this.damagesToAbsorb = damagesToAbsorb;
        this.damageAmount = damageAmount;
        this.actorIds = actorIds;
        this.__type = EffectType_1.EffectType.Redirect;
        this.__typeName = "Redirect";
        this.name = "Redirect";
        this.harmful = false;
    }
}
exports.RedirectEffectArgs = RedirectEffectArgs;
let RedirectEffectHandler = class RedirectEffectHandler {
    apply(sequence, container, state) {
        state.meta.damageAbsorbEffectId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.creatorId,
            effect: new __1.DamageAbsorbEffectArgs(state.args.damagesToAbsorb, state.args.damageAmount),
            duration: Duration_1.Duration.Permanent,
        });
        const onDamageAbsorbedScriptArgs = {
            redirectTo: state.args.actorIds
        };
        state.meta.damageAbsorbedEventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.DamageAbsorbed, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_Redirect_OnDamageAbsorbed", onDamageAbsorbedScriptArgs));
        const onAllyKilledScriptArgs = {
            redirectTo: state.args.actorIds,
            redirectEffectId: state.id
        };
        state.meta.cancelEffectEventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.AllyKilled, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_Redirect_OnAllyKilled", onAllyKilledScriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.damageAbsorbEffectId);
        container.cancelEventHandler(state.meta.damageAbsorbedEventHandlerId);
        container.cancelEventHandler(state.meta.cancelEffectEventHandlerId);
    }
};
RedirectEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Redirect)
], RedirectEffectHandler);
exports.RedirectEffectHandler = RedirectEffectHandler;
